import { iriLocalName } from "../../shared/references/shortReferences";
import { processVocabulary, type ProcessTerm } from "../generated/processVocabulary";

/**
 * Terms of the DMW process ontology, as the server exports them from `dmw-process.ttl`
 * (`generated/processVocabulary.ts`). The web app keeps no copy of the namespace, the names
 * or the literal types: a term the file no longer declares fails to compile.
 */

type LiteralTypeIri = (typeof processVocabulary.literalTypes)[number];

/** A literal type's local name, such as `boolean` for `xsd:boolean`. */
export type LiteralTypeName = LiteralTypeIri extends `${string}#${infer Name}` ? Name : never;

/** A term's IRI, such as `processTerm("Document")`. */
export function processTerm(name: ProcessTerm): string {
  return `${processVocabulary.namespace}${name}`;
}

/** A literal type's IRI, such as `literalType("boolean")`: one of the plain values' XML Schema datatypes the ontology lists. */
export function literalType(name: LiteralTypeName): string {
  const iri = processVocabulary.literalTypes.find((listed) => iriLocalName(listed) === name);
  if (iri === undefined) throw new Error(`The DMW process ontology lists no literal type ${name}.`);
  return iri;
}
